"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class BrandAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getLandingPageData(params) {
        try {
            return await this.client.get(`/mercury/v1/landing-page`, params);
        }
        catch (err) {
            if (axios_1.default.isAxiosError(err) && err.response?.status === 404) {
                return null;
            }
            throw err;
        }
    }
}
exports.default = BrandAPI;
//# sourceMappingURL=index.js.map